export default "__VITE_ASSET__69iE1xw5__"